export const watchOrReadListService = {
  query,
  getById,
  save,
  remove,
};

const STORAGE_KEY = 'watchOrReadList';

function _loadData() {
  return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
}

function _saveData(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

async function query(userId, listType) {
  const data = _loadData();
  const user = data.find((entry) => entry.userId === userId);
  return user?.[listType] || [];
}

async function getById(userId, listType, malId) {
  const list = await query(userId, listType);
  return list.find((item) => item.mal_id === malId) || null;
}

async function save(userId, listType, item) {
  const data = _loadData();
  const userIndex = data.findIndex((entry) => entry.userId === userId);

  if (userIndex === -1) {
    data.push({
      userId,
      [listType]: [item],
    });
  } else {
    const list = data[userIndex][listType] || [];
    const itemIndex = list.findIndex((i) => i.mal_id === item.mal_id);

    if (itemIndex === -1) {
      data[userIndex][listType] = [...list, item];
    } else {
      list[itemIndex] = { ...list[itemIndex], ...item };
      data[userIndex][listType] = list;
    }
  }

  _saveData(data);
  return item;
}

async function remove(userId, listType, malId) {
  const data = _loadData();
  const userIndex = data.findIndex((entry) => entry.userId === userId);

  if (userIndex === -1) throw new Error('User not found');

  const list = data[userIndex][listType] || [];
  data[userIndex][listType] = list.filter((item) => item.mal_id !== malId);

  _saveData(data);
  return malId;
}
